import AppResource from '@milestoneslabs/milestones-js-engine/src/Data/AppResource';

class C21OrganizationAppResource extends AppResource {

  /**
   * @returns {string}
   */
  appResourceType() {
    return 'c21-organization';
  }

  /**
   * @returns {string}
   */
  appResourceApiPrefix() {
    return 'c21s/organizations';
  }

  /**
   * @returns {*[]}
   */
  hidden() {
    return super.hidden().concat([
      'uuid',
      'deleted_at',
    ]);
  }

  /**
   * @returns {*[]}
   */
  fillable() {
    return [
      'organizationUuid',
      'c21LocationUuid',
    ];
  }

  /**
   * @returns {*[]}
   */
  relationMap() {
    return [
    ];
  }

  /**
   * @returns {*[]}
   */
  relationForeignKeys() {
    return [
    ];
  }

  /**
   * @returns {*}
   */
  validationRules() {
    return {
      organizationUuid: {
        type: 'string',
        presence: true,
      },
      c21LocationUuid: {
        type: 'string',
        presence: true,
      },
    }
  }

}

export default C21OrganizationAppResource;
